// "aktarıldı" rozeti — Geçmiş Rapor Aktarımı (tasarım review 4A / R13).
//
// `Project.hasImport` / `ArchiveListItem.hasImport` true iken ProjectsList ve
// ArchiveList'in Durum hücresinde durum pill'inin yanında görünür. NÖTR ton
// (`--color-bg` + `--color-border` + `--color-text-2`) — durum pill'iyle
// yarışmaz, yeni kolon açılmaz (mevcut e2e seçicileri korunur).

import { IMPORT_COPY } from "../../lib/report-import-ui";

export function ImportedPill(): JSX.Element {
  return (
    <span
      title={IMPORT_COPY.pageTitle}
      style={{
        padding: "1px 8px",
        borderRadius: 999,
        fontSize: "0.68rem",
        fontWeight: 600,
        background: "var(--color-bg)",
        color: "var(--color-text-2)",
        border: "1px solid var(--color-border)",
        whiteSpace: "nowrap",
      }}
    >
      {IMPORT_COPY.importedPill}
    </span>
  );
}
